import { bestOffer, products } from "@/lib/products";
import { productArt } from "@/components/ProductArt";

const currency = new Intl.NumberFormat("de-DE", {
  style: "currency",
  currency: "EUR",
  maximumFractionDigits: 0,
});

const featured = [
  {
    id: "escooter-urban",
    position: "top-[2%] left-[4%]",
    rot: "-6deg",
    delay: "0s",
    size: "h-28 w-28",
  },
  {
    id: "smartphone-128gb",
    position: "top-[8%] right-[2%]",
    rot: "5deg",
    delay: "1.1s",
    size: "h-20 w-20",
  },
  {
    id: "kopfhoerer-anc",
    position: "bottom-[26%] left-[0%]",
    rot: "4deg",
    delay: "0.6s",
    size: "h-20 w-20",
  },
  {
    id: "ultrabook-14",
    position: "bottom-[0%] right-[10%]",
    rot: "-4deg",
    delay: "1.6s",
    size: "h-24 w-24",
  },
] as const;

export function HeroProductChips() {
  return (
    <div className="relative h-full w-full">
      {featured.map(({ id, position, rot, delay, size }) => {
        const product = products.find((p) => p.id === id);
        if (!product) return null;
        const Art = productArt[product.art];
        const price = bestOffer(product.offers).price;

        return (
          <div
            key={id}
            className={`absolute ${position} animate-float`}
            style={{ animationDelay: delay, ["--float-rot" as string]: rot }}
          >
            <div
              className="relative rounded-2xl border border-foreground/10 bg-card p-4 ticket-shadow"
              style={{ transform: `rotate(${rot})` }}
            >
              <span className="punch-hole" />
              <Art className={`${size} text-foreground`} tone="tag" />
              <div className="mt-2 text-center">
                <div className="stamp text-primary">
                  ab {currency.format(price)}
                </div>
              </div>
            </div>
          </div>
        );
      })}
    </div>
  );
}
